
<template>
  <div class="w-full px-2">
    <h4 class="text-center mb-6">Styling Preview</h4>
    <p class="my-4 mx-auto text-base text-center">Upload your business logo and choose a background color to see what it will look like.</p>
    <div class="w-full mx-auto relative pt_iframeloadwrap">
          <div class="pt_absolute_center z-m1" v-if="!fileUrl">
            <img class="w-10 spinner block mx-auto spinimg" src="@/assets/images/logo/smiley.png"/>
            <p class="mt-2 text-dark">Loading preview...</p>
          </div>
          <iframe name="previewframe" class="bg-white block w-full max-w-md lg:max-w-xl xxl:max-w-2xl mx-auto h-124 md:h-110 xxl:h-134 shadow-iframe border-none rounded"/>          
    </div>
    <div class="vx-col w-full">
        <div class="text-center my-8">
          <p class="mx-auto max-w-sm mb-5 text-base">Your Feedback Link surveys will work on all modern smartphone, tablet and computer web browsers.</p>
          <img src="@/assets/images/misc/alldevices.png" class="w-40" >
        </div>
    </div>
  </div>
</template>

<script>

import store from '../../../store/store'
import signupComputedVmodel from '../common/setSignupComputedVmodel'
import debounce from 'debounce'

export default {
  data() {
    return {
      iframeSrc: 'https://feedback.link/demo'
    }
  },
  methods: {
    updateIframe:  debounce( function () {      

      //post into iframe to get survey preview
      const form = document.createElement('form')
      form.method = 'post';
      
      if (process.env.NODE_ENV === 'development') {
        form.action = 'http://localhost:1088/mysurveypreview';
      } else {
        const isAgencyClient = this.$store.getters['dash/isAgencyClientCollaborator']
        form.action = `https://${isAgencyClient ? 'givefdbck.com' : 'feedback.link'}/mysurveypreview`;
      }   

      form.target = 'previewframe'

      const postData = {
        isAgencyClient: this.$store.getters['dash/isAgencyClientCollaborator'],
        previewType: 'lookandfeel',
        appearanceInfo: this.$store.state.signUpState.recorded.appearance,
        businessInfo: this.$store.state.signUpState.recorded.businessInfo,
        language: this.$store.state.signUpState.recorded.signupLanguageChoice
      }
       
      const hiddenField = document.createElement('input')
      hiddenField.type = 'hidden'
      hiddenField.name = 'json'
      hiddenField.value = JSON.stringify(postData)
      form.appendChild(hiddenField)

      //noconsoleconsole.log(postData)

      document.body.appendChild(form)
      
      form.submit()      

      setTimeout(() => {
        form.remove()
      }, 500)

    }, 1000)
  },
  computed: {
    businessName: signupComputedVmodel(store, ['businessInfo', 'businessName']),  
    showWhiteLogoBorder: signupComputedVmodel(store, ['appearance', 'showWhiteLogoBorder']),
    showWhiteLogoBackground: signupComputedVmodel(store, ['appearance', 'showWhiteLogoBackground']),
    colorHex: signupComputedVmodel(store, ['appearance', 'backgroundHex']),
    secondaryHex: signupComputedVmodel(store, ['appearance', 'secondaryHex']),
    fileUrl: signupComputedVmodel(store, ['appearance', 'logoUrl'])
  },
  watch: {
    fileUrl() {
      this.updateIframe(this)
    },
    secondaryHex: {
      deep: true,
      handler(v) {
        this.updateIframe()
      }
    },
    colorHex: {
      deep: true,
      handler(v) {
        this.updateIframe()
      }
    },
    showWhiteLogoBorder(){
      this.updateIframe()
    },
    showWhiteLogoBackground(){
      this.updateIframe()
    },
    businessName(){
      this.updateIframe()
    }
  },
  mounted() {
    this.updateIframe()
  }
}

</script>
